import React from "react";

import "./WhyUs.scss";
import { Link } from "react-router-dom";

import r1 from "./assets/r1.svg";
import r2 from "./assets/r2.svg";
import r3 from "./assets/r3.svg";
import r4 from "./assets/r4.svg";
import r5 from "./assets/r5.svg";
import r6 from "./assets/r6.svg";
import Cta from "./Cta";

const WhyUsAza = () => {
  return (
    <section className="why-us why-us__wrapper">
      <h2>Choosing the right form tool makes all the difference.</h2>
      <p>Here’s why Azaform stands out:</p>
      <div className="container">
        <div className="why-us__reasons">
          <div className="why-us__reason">
            <img src={r1} alt="Click illustration" />
            <h4>Quick setup</h4>
            <p>
              Launch forms in minutes with a simple, no‑code builder—no technical skills needed.
            </p>
            <Link to="/register">Get started</Link>
          </div>
          <div className="why-us__reason">
            <img src={r2} alt="QR illustration" />
            <h4>Easy sharing</h4>
            <p>
              Share via email, QR codes, or direct links so anyone can submit without signing up.
            </p>
            <Link to="/register">Get started</Link>
          </div>
          <div className="why-us__reason">
            <img src={r3} alt="Device illustration" />
            <h4>Works on any device</h4>
            <p>
              Optimized for desktops, tablets, and smartphones for seamless access anywhere.
            </p>
            <Link to="/register">Get started</Link>
          </div>
          <div className="why-us__reason">
            <img src={r4} alt="Scaling illustration" />
            <h4>Fits any use case</h4>
            <p>
              From registrations to contact forms and surveys, scale effortlessly for any scenario.
            </p>
            <Link to="/register">Get started</Link>
          </div>
          <div className="why-us__reason">
            <img src={r5} alt="Star illustration" />
            <h4>Organized responses</h4>
            <p>
              View all submissions in one place with options to export and analyze.
            </p>
            <Link to="/register">Get started</Link>
          </div>
          <div className="why-us__reason">
            <img src={r6} alt="Restart Icon" />
            <h4>Start fresh anytime</h4>
            <p>
              Create new forms for each occasion—keep things organized and up to date.
            </p>
            <Link to="/register">Get started</Link>
          </div>
        </div>
      </div>

      <div className="container">
        <Cta />
      </div>
    </section>
  );
};

export default WhyUsAza;